(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    class StrongProductCard extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.setupMobileTrigger();
      this.setupAddToCart();
      this.setupClickOutside();
    }

    setupMobileTrigger() {
      const trigger = this.querySelector('[data-mobile-cart-trigger]');
      if (!trigger) return;

      let touchStartTime;
      
      trigger.addEventListener('touchstart', () => {
        touchStartTime = Date.now();
      }, { passive: true });
      
      trigger.addEventListener('touchend', (e) => {
        const touchDuration = Date.now() - touchStartTime;
        
        if (touchDuration < 200) {
          e.preventDefault();
          e.stopPropagation();
          
          const productCard = this.querySelector('.strong-product-card');
          const hasSubscribe = this.querySelector('.strong-product-card__subscribe') !== null;
          
          productCard.classList.toggle('mobile-active');
          
          if (hasSubscribe) {
            productCard.classList.toggle('has-subscribe', productCard.classList.contains('mobile-active'));
          }
          
          // Close other active cards
          document.querySelectorAll('.strong-product-card.mobile-active').forEach(card => {
            if (card !== productCard) {
              card.classList.remove('mobile-active');
              card.classList.remove('has-subscribe');
            }
          });
        }
      });
    }

    setupAddToCart() {
      const form = this.querySelector('[data-product-form]');
      if (!form) return;

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        const button = form.querySelector('.strong-product-card__add-to-cart');
        const variantIdInput = form.querySelector('input[name="id"]');
        
        if (!variantIdInput || !variantIdInput.value) {
          alert('Product variant not found');
          return;
        }
        
        button.classList.add('loading');
        button.disabled = true;
        
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: parseInt(variantIdInput.value),
              quantity: 1
            })
          });
          
          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.description || 'Failed to add to cart');
          }
          
          button.classList.remove('loading');
          button.classList.add('atc-added');
          
          // Dispatch event for cart drawer
          document.dispatchEvent(new CustomEvent('cart:item-added', {
            detail: { variantId: parseInt(variantIdInput.value) }
          }));
          
          // Reset button state after delay
          setTimeout(() => {
            button.classList.remove('atc-added');
            button.disabled = false;
          }, 2000);
          
        } catch (error) {
          console.error('Cart error:', error);
          button.classList.remove('loading');
          button.disabled = false;
          alert(error.message || 'Failed to add to cart');
        }
      });
    }

    setupClickOutside() {
      document.addEventListener('click', (e) => {
        if (!e.target.closest('product-card')) {
          const activeCards = document.querySelectorAll('.strong-product-card.mobile-active');
          activeCards.forEach(card => {
            card.classList.remove('mobile-active');
            card.classList.remove('has-subscribe');
          });
        }
      });
    }
  }

  customElements.define('strong-product-card', StrongProductCard);

  // Wrap product cards if not already wrapped
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.strong-product-card').forEach(card => {
      if (!card.closest('strong-product-card')) {
        const wrapper = document.createElement('strong-product-card');
        card.parentNode.insertBefore(wrapper, card);
        wrapper.appendChild(card);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
